import { Case } from "@/extensions/klarahill/types";
import { Layout } from "@/extensions/obituary/types";

import { Container } from "./Item/Container";
import { Story } from "./shared";

export type templateFn = (c: Case) => Story;

/**
 * Obituaries share the same template.
 * Two column layout is identical, but allows for `splits` in `relatives`.
 */
const obituary: templateFn = (c) => [
  {
    type: "container",
    id: crypto.randomUUID(),
    variant: "header",
    gap: true,
    children: [
      {
        type: "image",
        id: crypto.randomUUID(),
        variant: "top-image",
        src: "gallery/13606.bmp",
        height: 22,
      },

      {
        type: "multiline",
        id: crypto.randomUUID(),
        variant: "greeting",
        text: c.memorial?.text ?? "",
      },

      {
        type: "singleline",
        id: crypto.randomUUID(),
        variant: "heading",
        text: `${c.deceased.first_name} ${c.deceased.last_name}`,
      },
    ],
  },

  {
    type: "container",
    id: crypto.randomUUID(),
    variant: "deceased",
    children: [
      {
        type: "date",
        id: crypto.randomUUID(),
        variant: "birth-date",
        date: c.deceased.birth_date,
        prefix: ":asterisk:",
        wrap: true,
      },

      {
        type: "multiline",
        id: crypto.randomUUID(),
        variant: "epitaph",
        text: "har lämnat oss i stor sorg och saknad",
      },

      {
        type: "date",
        id: crypto.randomUUID(),
        variant: "deceased-date",
        date: c.deceased.deceased_date,
        prefix: ":dagger:",
        wrap: true,
      },
    ],
  },

  {
    type: "container",
    id: crypto.randomUUID(),
    variant: "relatives",
    gap: true,
    children: [
      {
        type: "container",
        variant: "relatives-row",
        id: crypto.randomUUID(),
        flex: "row",
        children: [
          {
            type: "container",
            variant: "relative,relatives-column",
            id: crypto.randomUUID(),
            flex: "column",
            gap: true,
            children: [
              {
                type: "singleline",
                id: crypto.randomUUID(),
                variant: "mourners",
                text: `${c.customers?.[0]?.first_name ?? ""}`,
              },
            ],
          } satisfies Container,
        ],
      } satisfies Container,
    ],
  },

  {
    type: "container",
    id: crypto.randomUUID(),
    variant: "anthology",
    gap: true,
    children: [
      {
        type: "divider",
        id: crypto.randomUUID(),
        size: "small",
        hidden: true,
      },
      {
        type: "multiline",
        id: crypto.randomUUID(),
        variant: "poem",
        text: "",
      },
      {
        type: "singleline",
        id: crypto.randomUUID(),
        variant: "author",
        text: "",
      },
    ],
  },

  {
    type: "container",
    id: crypto.randomUUID(),
    variant: "ending",
    gap: true,
    children: [
      {
        type: "divider",
        id: crypto.randomUUID(),
        size: "large",
      },

      {
        type: "multiline",
        id: crypto.randomUUID(),
        variant: "funeral",
        text: `${c.funeral?.information ?? ""}${c.reception?.information && c.funeral?.information ? "\n\n" : ""}${c.reception?.information ?? ""}`,
      },

      {
        type: "multiline",
        id: crypto.randomUUID(),
        variant: "farewell",
        text: "",
      },

      {
        type: "singleline",
        id: crypto.randomUUID(),
        variant: "url",
        text:
          c.office.host_url && c.office.memorials_path
            ? `Bidra med ett minne på ${c.office.host_url}${c.office.memorials_path}`
            : "",
      },
    ],
  },
];

const thanks: templateFn = (c) => [
  {
    type: "container",
    id: crypto.randomUUID(),
    variant: "header",
    gap: true,
    children: [
      {
        type: "singleline",
        id: crypto.randomUUID(),
        variant: "default",
        text: "Ett stort tack",
      },

      {
        type: "image",
        id: crypto.randomUUID(),
        variant: "top-image",
        src: "gallery/13607.bmp",
        height: 14,
      },

      {
        type: "multiline",
        id: crypto.randomUUID(),
        variant: "default",
        text: "att ni var med och sörjde efter minnet av",
      },

      {
        type: "singleline",
        id: crypto.randomUUID(),
        variant: "heading",
        text: `${c.deceased.first_name} ${c.deceased.last_name}`,
      },

      {
        type: "multiline",
        id: crypto.randomUUID(),
        variant: "default",
        text: "vid hans begravning",
      },
    ],
  },

  {
    type: "container",
    id: crypto.randomUUID(),
    variant: "relatives",
    children: [
      {
        type: "container",
        variant: "relatives-row",
        id: crypto.randomUUID(),
        flex: "row",
        children: [
          {
            type: "container",
            variant: "relative,relatives-column",
            id: crypto.randomUUID(),
            flex: "column",
            gap: true,
            children: [
              {
                type: "singleline",
                id: crypto.randomUUID(),
                variant: "mourners",
                text: `${c.customers?.[0]?.first_name ?? ""}`,
              },
            ],
          } satisfies Container,
        ],
      } satisfies Container,
    ],
  },

  {
    type: "container",
    id: crypto.randomUUID(),
    variant: "ending",
    gap: true,
    children: [
      {
        type: "multiline",
        id: crypto.randomUUID(),
        variant: "farewell",
        text: "",
      },
    ],
  },
];
const template: Record<Layout, templateFn> = {
  OBITUARY_ONE_COLUMN: obituary,
  OBITUARY_TWO_COLUMN: obituary,
  THANKS: thanks,
};

export default template;
